import { colorTokensMap, gradientColorTokensMap, } from '../colors';
import { buttonTypeTokensMap } from './button';
import { borderRadiusTypeTokensMap } from './borderRadius';
import { sizeTypeTokensMap } from './space';
import { inputTypeTokensMap } from './textInput';
import { fontSizeTokensMap, fontFamilyTokensMap, typographyTypeTokensMap, } from './typography';
import { shadowTypeTokensMap } from './shadow';
import { IconSizeTokensMap } from './icons';
import { avatarTypeTokensMap } from './avatar';
import { aspectRationTokensMap, imageTypeTokensMap, paddingTypeTokensMap, } from './image';
import { chatCardTypeTokenMap } from './chatCard';
import { progessIndicatorTypeTokensMap } from './progressIndicator';
import { dividerSizeTypeTokensMap } from './divider';
import { lottieSizeTokensMap } from './lottie';
import { tagTypeTokensMap } from './tag';
import { chipTypeTokensMap } from './chip';
import { lineItemCardTypeTokenMap } from './lineItemCard';
import { messageTypeTokenMap } from './message';
import { headerTypeTokenMap } from './header';
import { stepperTypeTokensMap } from './stepper';
import { infoTypeTokenMap } from './info';
import { selectiveListItemStateMap } from './selectiveListItem';
import { bottomTabStateMap } from './bottomTab';
import { listTypeTokenMap } from './list';
import { shimmerIconTypeTokensMap } from './shimmerIcon';
export const lightMobileTheme = {
    colors: colorTokensMap,
    gradientColor: gradientColorTokensMap,
    button: buttonTypeTokensMap,
    borderRadius: borderRadiusTypeTokensMap,
    space: sizeTypeTokensMap,
    fontFamily: fontFamilyTokensMap,
    textInput: inputTypeTokensMap,
    fontSize: fontSizeTokensMap,
    shadow: shadowTypeTokensMap,
    iconSize: IconSizeTokensMap,
    avatarSize: avatarTypeTokensMap,
    imageSize: imageTypeTokensMap,
    paddingSize: paddingTypeTokensMap,
    aspectRatio: aspectRationTokensMap,
    chatCard: chatCardTypeTokenMap,
    typography: typographyTypeTokensMap,
    progressIndicator: progessIndicatorTypeTokensMap,
    dividerSize: dividerSizeTypeTokensMap,
    lottieSize: lottieSizeTokensMap,
    tag: tagTypeTokensMap,
    chip: chipTypeTokensMap,
    lineItemCard: lineItemCardTypeTokenMap,
    message: messageTypeTokenMap,
    header: headerTypeTokenMap,
    selectiveListItem: selectiveListItemStateMap,
    stepper: stepperTypeTokensMap,
    info: infoTypeTokenMap,
    bottomTab: bottomTabStateMap,
    list: listTypeTokenMap,
    shimmerIcon: shimmerIconTypeTokensMap,
};
